/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import MeasureType, { MeasureTypeStrings } from 'enums/MeasureType'

/* eslint-disable import/prefer-default-export */
export const getChildTypes = (
  viewOption: InsightViewOptionStrings,
  measureType: MeasureTypeStrings
) => {
  switch (viewOption) {
    case InsightViewOption.OVERVIEW:
      switch (measureType) {
        case MeasureType.POSTS:
          return [MeasureType.POST_VIDEOS, MeasureType.POST_IMAGES, MeasureType.POST_OTHER]
        case MeasureType.NET_SENTIMENT:
          return [MeasureType.POSITIVES, MeasureType.NEGATIVES]
        case MeasureType.MENTIONS:
        case MeasureType.UNIQUE_AUTHORS:
        case MeasureType.IMPRESSIONS:
        case MeasureType.PASSION_INTENSITY:
        default:
          return []
      }
    default:
      return []
  }
}
